<template>
  <div>
    <input 
        :id="id"
        v-model="checker[id]"
        class="landing__checkbox-input"
        type="checkbox"
        :disabled="disabled"
    >
    <label class="landing__checkbox-label" :for="id">
        <span class="landing__checkbox-icon">
            <img class="icon" :src="require(`@/create/assets/icons/${icon}.svg`)" alt="">
        </span>
        <slot class="landing__checkbox-slotted-text"></slot>
    </label>
  </div>
</template>

<script>
  export default {
    props: ['id', 'checker', 'icon', 'disabled']
  }
</script>

<style lang="scss" scoped>
.landing__checkbox {
  &-input {
    display: none;
  }

  &-label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &-icon {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      opacity: 0;
    }
  }

  &-input:checked + &-label > span > img {
    opacity: 1;
  }

  &-input:disabled + &-label {
    cursor: default;
  }
}

</style>